/**
 * 模拟的分类统计数据
 * 用于开发环境或当Supabase连接不可用时
 */
export const mockCategoryStats = [
  {
    category: 'AI行业动态',
    feeds: [
      { feedId: 'ai-1', feedName: 'AI研究动态', articleCount: 25 },
      { feedId: 'ai-2', feedName: 'AI应用案例', articleCount: 18 },
      { feedId: 'ai-3', feedName: '大模型进展', articleCount: 32 }
    ]
  },
  {
    category: 'Web3动态',
    feeds: [
      { feedId: 'web3-1', feedName: '区块链新闻', articleCount: 15 },
      { feedId: 'web3-2', feedName: 'NFT市场', articleCount: 8 },
      { feedId: 'web3-3', feedName: '加密货币趋势', articleCount: 22 }
    ]
  },
  {
    category: '企业家动态',
    feeds: [
      { feedId: 'ent-1', feedName: '创业故事', articleCount: 12 },
      { feedId: 'ent-2', feedName: '企业家访谈', articleCount: 9 }
    ]
  },
  {
    category: '投资人动态',
    feeds: [
      { feedId: 'inv-1', feedName: '风投动态', articleCount: 17 },
      { feedId: 'inv-2', feedName: '投资案例', articleCount: 14 },
      { feedId: 'inv-3', feedName: '市场趋势分析', articleCount: 20 }
    ]
  },
  {
    category: '一人公司动态',
    feeds: [
      { feedId: 'solo-1', feedName: '独立开发者', articleCount: 10 },
      { feedId: 'solo-2', feedName: '一人公司故事', articleCount: 7 }
    ]
  }
];

/**
 * 分类颜色映射
 */
export const categoryColorMap = {
  'AI行业动态': '#FF6384',
  'Web3动态': '#36A2EB',
  '企业家动态': '#4BC0C0',
  '投资人动态': '#FFCE56',
  '一人公司动态': '#9966FF',
  '科技最新资讯': '#FF9F40'
}; 